import { Check, ShieldCheck } from 'lucide-react';
import { CampaignBrokerActions } from './CampaignBrokerActions';

export const CampaignBrokerCard = ({ broker, featured = false, position }) => {
  const metrics = [
    { key: 'deposit', label: 'Min. deposit', value: broker.min_deposit },
    { key: 'spreads', label: 'Spreads', value: broker.fees?.spreads },
    { key: 'leverage', label: 'Max. leverage', value: broker.leverage },
    { key: 'platforms', label: 'Platforms', value: broker.platforms },
  ];

  return (
    <li className={`campaign-broker ${featured ? 'campaign-broker-featured' : 'campaign-broker-peer'}`}
      data-testid={`campaign-broker-${broker.slug}`} data-featured={featured}>
      {featured && (
        <div className="campaign-featured-banner" data-testid="campaign-featured-banner">
          <ShieldCheck size={16} aria-hidden="true" /> Featured broker · {broker.name}
        </div>
      )}
      <div className="campaign-broker-body">
        <div className="campaign-identity">
          {!featured && <span className="campaign-position" aria-hidden="true" data-testid={`campaign-position-${broker.slug}`}>{position}</span>}
          <div className="min-w-0">
            <h3 className="campaign-broker-name" data-testid={`campaign-name-${broker.slug}`}>{broker.name}</h3>
            <p className="campaign-regulation" data-testid={`campaign-regulation-${broker.slug}`}>
              {featured && <Check size={15} aria-hidden="true" />}
              <span><span className="sr-only">Regulation: </span>{broker.regulation || 'Not provided'}</span>
            </p>
            {featured && (
              <p className="campaign-accounts" data-testid={`campaign-accounts-${broker.slug}`}>
                <Check size={15} aria-hidden="true" />
                <span><span className="font-medium">Account types:</span> {broker.account_types || 'Not provided'}</span>
              </p>
            )}
          </div>
        </div>
        <dl className="campaign-metrics">
          {metrics.map(({ key, label, value }) => (
            <div className="campaign-metric" key={key} data-testid={`campaign-${key}-${broker.slug}`}>
              <dt>{label}</dt>
              <dd>{value || 'Not provided'}</dd>
            </div>
          ))}
        </dl>
        <CampaignBrokerActions broker={broker} featured={featured} />
      </div>
    </li>
  );
};